<template>
  <div class="orderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:10px"></div>
    <div class="order-item" v-for="(item,i) in order">
      <div class="title">
        <div class="address">{{item.title}}</div>
        <div class="timer">{{item.status == 2 ? '已购买' : '已完成'}}</div>
      </div>
      <div class="product">
        <div class="left">
          <img style="float:left;width:30%;margin-left:4%;border-radius: 5px;" :src="baseUrl+item.img" />
          <div class="names">
            <div class="bt">{{item.address}}</div>
            <div class="number">订单编号：{{item.orderSn}}</div>
            <div class="t"><font v-if="item.classes == 2 && item.status == 2" style="color:#FF6600;padding-right:10px;font-weight:bold">已使用{{item.times}}小时</font>{{item.createtime}}</div>
          </div>
        </div>
      </div>

      <div class="bottom">
        <div class="rank" v-if="item.status == 2 && item.classes==1" @click="findPwd(item.id,0)">查看密码</div>
        <span v-if="item.status == 2 && item.classes==2">
        <div class="rank" @click="findPwd(item.id,1)" v-if="item.price >= item.times">存物密码</div>
        <div class="rank" style="margin-left:20px;color:#FF6600" @click="endpwd(item.id)">取物密码</div>
        </span>
        <span v-if="item.status == 4 && item.classes==2">
          {{item.end_pwd}}
        </span>
        <div class="price">
          <span>共1次</span>
          <span class="last">
            <i><b>¥</b> {{item.price.split(".")[0]}}.<b>{{item.price.split(".")[1]}}</b></i>
          </span> 
        </div>
      </div>
    </div>  

    <div class="none" v-if="order.length <= 0 ">
      <img src="~assets/images/none.png">
      <p>您没有购买空间服务 <font color="red">我要购买 </font></p>
    </div>

    <el-dialog title="提示您的开锁密码为" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div id="username">开锁密码：{{pwd.keyboardPwd}}</div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        order:[],
        curHeight:0,
        fullscreenLoading: true,
        active:1,
        baseUrl:'',
        code:'',
        pwd:[],
        dialogFormVisible:false
      };
    },
    created(){
      if(localStorage.getItem('user') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/clustOrder');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
      }
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      if(localStorage.getItem('user') == null){
        this.login();
      }
      this.beforeMount();
      this.getOrder();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },  
      backTop:function(){
        const that = this;
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
      },
      findPwd:function(id,type){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/lock/getPwd',
          params:{
            id:id,
            type:type
          }
        }).then(function(response){
          that.fullscreenLoading = false
          var res = response.data.data;
          that.pwd = res;
          that.dialogFormVisible = true;
          that.getOrder();
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      endpwd:function(id){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/lock/endpwd',
          params:{
            id:id
          }
        }).then(function(response){
          that.fullscreenLoading = false
          var res = response.data.data;
          if(response.data.status == 403){
            that.jsApiCall(res)
          }else if(response.data.status == 200){
            that.pwd = res;
            that.dialogFormVisible = true;
            that.getOrder();
          }
          
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    that.getOrder();
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },

      getOrder:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/lock/getClustOrder',
          params:{
            user_id:that.userData.id,
          }
        }).then(function(response){
          that.fullscreenLoading = false
          var res = response.data.data;
          that.order = res;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('user', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-dialog{
    width:80% !important;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .orderApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-bottom:5px
  }
  .orderApp .order-tab{
    position:fixed;
    width:100%;
    height:45px;
    left:0;
    top:0;
    background:#eaeaea;
    z-index:99
  }
  .orderApp .order-tab span{
    display:inline-block;
    width:33.3%;
    text-align:center;
    line-height:45px;
    font-size:15px;
    font-weight:bold;
    position:relative;
  }
  .orderApp .order-tab span.curt{
    color:#406DE1;
  }
  .orderApp .order-tab span.curt:after{
    position:absolute;
    content:'';
    width:30px;
    height:1px;
    background:#406DE1;
    bottom:0;
    left:50%;
    transform: translateX(-50%);
  }
  .orderApp .order-item{
    width: 94%;
    display: block;
    background: #fff;
    margin: 0px auto 10px auto;
    border-radius: 6px;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .orderApp .order-item .title{
    height: 30px;
    display: block;
    line-height: 30px;
    padding:10px 4% 5px 4%;
  }
  .orderApp .order-item .title .address{
    float: left;
    font-size: 15px;
    font-weight:bold;
    color:#333
  }
  .orderApp .order-item .title .timer{
    float: right;
    font-size: 14px;
    color: #FF6600;
    font-weight:bold;
  }
  .orderApp .order-item .product .left:after,.orderApp .order-item .btn:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  } 
  .orderApp .order-item .product .left .names{
    float:left;
    margin-left:2%;
    position:relative;
    width:62%;
  }
  .orderApp .order-item .product .left .names .bt{
    font-size: 14px;
    color: #333;
    font-weight:bold;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2; 
    width: 100%;
    margin-top:-1px;
    padding-bottom:5px
  }
  .orderApp .order-item .product .left .names .number{
    font-size: 14px;
    color: #999999;
    padding-bottom:8px
  }
  .orderApp .order-item .product .left .names .jg{
    font-size:14px;
    font-weight:bold;
    color:#fa0024;
  }
  .orderApp .order-item .product .left .names .jg span{
    font-size:11px;
    color: #727272;
    padding-left:5px;
  }
  .orderApp .order-item .product .left .names .t{
    color: #999999;
    font-size:14px;
  }

  .orderApp .order-item .bottom{
    width:92%;
    margin:0 auto;
    height:50px;
    padding-top:10px;
  }
  .orderApp .order-item .bottom .rank{
    float:left;
    background: #F7FAFF;
    border-radius: 10px;
    color: #2F78FF;
    font-size:13px;
    padding:6px 10px;
  }
  .orderApp .order-item .bottom .price{
    float:right;
    padding-top:6px;
  }

  .orderApp .order-item .bottom .price span:first-child{
    font-size: 14px;
    color: #999999;
    padding-right:10px;
  }
  .orderApp .order-item .bottom .price i{
    color: #FF6600;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .orderApp .order-item .bottom .price b{
    font-size:12px;
  }


  .orderApp .none{
    text-align:center;
    padding-top:50%
  }
  .orderApp .none img{
    width:120px;
  }
  .orderApp .none p{
    color:#cdcdcd;
    font-size:14px;
  }

  .orderApp .el-dialog__header{
    text-align:center;
  }
  .orderApp .el-dialog__title{
    font-weight: bold;
    color: #0FB144;
    
  }
  .orderApp #el-drawer__title span{
    text-align:center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #2F78FF;
  }

#username{
    text-align:center;
    font-size:18px;
    color:#000;
    padding-bottom:50px
  }

</style>